import axios from 'axios';

export const getAllRule = async () => {
    const url = `/api/v1/user_profile/request_filter_rules`;
    const res = await axios.get(url);
    return res.data;
};

export const createRule = async (rule) => {
    const url = `/api/v1/user_profile/request_filter_rules`;
    const res = await axios.post(url, rule);
    return res.data;
};

export const deleteRule = async (ruleId) => {
    const url = `/api/v1/user_profile/request_filter_rules/${ruleId}`;
    const res = await axios.delete(url);
    return res.data;
};

export const getFilteredRequests = async (ruleId, page=1, items=20) => {
    const url = `/api/v1/user_profile/request_filter_rules/${ruleId}/filtered_requests?page=${page}&items=${items}`;
    const res = await axios.get(url);
    return res.data;
};

export const resendFilteredRequests = async (ruleId, requestId) => {
    const url = `/api/v1/user_profile/request_filter_rules/${ruleId}/filtered_requests/${requestId}`;
    const res = await axios.patch(url);
    return res.data;
};